import {
	wifiEncryptionAtom,
	wifiHiddenAtom,
	wifiNameAtom,
	wifiPasswordAtom,
} from 'features/generator/contentFormSections/WifiForm'
import { atom } from 'jotai'

import { QR_TYPE } from '../../generatorTypes'

export type TWifiContent = {
	type: QR_TYPE.Wifi
	ssid: string
	password: string
	encryption: string
	hidden: boolean
}

export const wifiContentAtom = atom<TWifiContent, [TWifiContent], void>(
	(get) => ({
		type: QR_TYPE.Wifi,
		ssid: get(wifiNameAtom) || '',
		password: get(wifiPasswordAtom) || '',
		encryption: get(wifiEncryptionAtom) || '',
		hidden: get(wifiHiddenAtom) || false,
	}),
	(_, set, content: TWifiContent) => {
		set(wifiNameAtom, content.ssid)
		set(wifiPasswordAtom, content.password)
		set(wifiEncryptionAtom, content.encryption)
		set(wifiHiddenAtom, content.hidden)
	},
)
